import gql from "graphql-tag";

export const userGroupRolesQuery = gql`
  query userGroupRoles($id: ID!) {
    user(id: $id) {
      id
      userGroup {
        id
        roles
      }
    }
  }
`;
